import { Link } from 'common-components'

import MESSAGES from 'core/data-model/constants/messages'
import { AcceptFundAllocationButton } from 'quick-quote/components/accept-fund-allocation-btn'
import { ROUTE_PATH } from 'quick-quote/constants/path'
import { requireLstuFundAllocation } from 'quick-quote/product-investment/fund-allocation/lstu/selectors'
import { updateRppAcceptFundAllocation } from 'quick-quote/product-investment/fund-allocation/rpp/actions'
import { getRppAcceptFundAllocation } from 'quick-quote/product-investment/fund-allocation/rpp/selectors'
import {
  canProceedToInvestmentBenefitIllustration,
  canProceedToLstuFundAllocation,
} from 'quick-quote/product-investment/journey-control-selectors'
import { useDispatch, useSelector } from 'react-redux'
import { Button } from 'reactstrap'

const AcceptFundAllocationButtonComponent = (props) => {
  const dispatch = useDispatch()
  const acceptedRppFundAllocation = useSelector(getRppAcceptFundAllocation)
  const isCanProceedToBenefitIllustration = useSelector(canProceedToInvestmentBenefitIllustration)
  const isCanProceedToLstuFundAllocation = useSelector(canProceedToLstuFundAllocation)
  const isRequireLstuFundAllocation = useSelector(requireLstuFundAllocation)

  const nextTabDisabled = isRequireLstuFundAllocation
    ? isCanProceedToLstuFundAllocation
    : isCanProceedToBenefitIllustration

  const handleUpdateAcceptFundAllocation = (value) => {
    dispatch(updateRppAcceptFundAllocation(value))
  }

  return (
    <div>
      {acceptedRppFundAllocation ? (
        <div>
          <Link
            style={{ pointerEvents: nextTabDisabled ? 'auto' : 'none' }}
            to={
              isRequireLstuFundAllocation
                ? ROUTE_PATH.INVESTMENT.LSTU_FUND_ALLOCATION
                : ROUTE_PATH.INVESTMENT.BENEFIT_ILLUSTRATION
            }
          >
            <Button color={nextTabDisabled ? 'primary' : 'disabled'}>
              {isRequireLstuFundAllocation ? MESSAGES.LSTU_FUND : MESSAGES.BENEFIT_ILLUSTRATION}
            </Button>
          </Link>
        </div>
      ) : (
        <div>
          <AcceptFundAllocationButton
            disabled={props.disabled}
            acceptFundAllocation={() => handleUpdateAcceptFundAllocation(true)}
            message={MESSAGES.SUBMIT}
          />
        </div>
      )}
    </div>
  )
}

export default AcceptFundAllocationButtonComponent
